import { BiLogoReact, BiLogoPython, BiLogoTailwindCss, BiLogoJavascript } from "react-icons/bi";
import { SiFastapi, SiFirefoxbrowser, SiHuggingface, SiDocker } from "react-icons/si";
import { TbVectorBezier, TbDatabase, TbSearch } from "react-icons/tb";

const ProjectsData = [
  {
    id: "1",
    name: "YouTube RAG Assistant: Multilingual Video AI",
    image: "/yt-rag.png", 
    icons: [SiFirefoxbrowser, BiLogoPython, TbVectorBezier],
    shortDesc: "AI browser extension for real-time semantic chat with YouTube videos.",
    longDesc: [
      "Architected a full-stack AI browser extension and scalable backend allowing users to chat with long-form YouTube videos in real-time using an advanced Retrieval-Augmented Generation (RAG) pipeline.",
      "Engineered a robust data ingestion pipeline featuring language detection, on-the-fly translation, and sliding-window chunking with semantic overlap to maintain context boundaries across large transcripts.",
      "Built a two-stage retrieval pipeline using FAISS with all-MiniLM embeddings for high-speed vector search, followed by an MS-MARCO Cross-Encoder for reranking retrieved documents to maximize context precision.",
      "Implemented Agentic RAG features including LLM-driven query rewriting, guardrailing, and dynamic intent routing.",
      "Designed a strided document sampling strategy (map-reduce style) to accurately summarize multi-hour videos without exceeding LLM context windows or losing global context.",
      "Utilized strict prompt engineering with Qwen2.5-7B-Instruct to generate hallucination-free, dynamically sized answers, strictly enforced with multiple inline clickable video timestamps [MM:SS]."
    ],
    techStack: "Python, LangChain, FAISS, Hugging Face Inference Endpoints (Qwen 2.5), Sentence-Transformers, Flask, Docker, JS.",
    github: "https://github.com/ombhaltilak/youtube-rag-ai-assistant",
    demo: "https://addons.mozilla.org/en-US/firefox/addon/youtube-rag-assistant/", // Firefox Add-on Live Link
  },
  {
    id: "2",
    name: "Offline Document Finder (ODF)",
    image: "/odf-thumb.png", 
    icons: [BiLogoPython, TbDatabase, TbSearch],
    shortDesc: "Privacy-first, local-first AI semantic search engine for desktop.",
    longDesc: [
      "Architected and developed a fully offline, privacy-first AI-powered desktop search engine enabling semantic retrieval across local documents (PDF, DOCX, XLSX, TXT) using natural language queries instead of exact keyword matching.",
      "Designed a high-performance semantic indexing pipeline using FastEmbed with ONNX Runtime, dynamically leveraging NVIDIA CUDA for GPU acceleration while maintaining optimized CPU-only fallback execution.",
      "Implemented persistent local vector storage using ChromaDB, enabling efficient similarity search with disk-based embedding storage for scalable document indexing.",
      "Built a lightweight desktop interface using CustomTkinter with global system-wide hotkey support (Ctrl + K) for instant search access.",
      "Packaged the application into a standalone Windows executable using PyInstaller, ensuring zero external dependencies and 100% local execution."
    ],
    techStack: "Python, ChromaDB, FastEmbed, ONNX Runtime (CPU/GPU), CustomTkinter, PyInstaller, PyMuPDF (Fitz), OpenPyXL.",
    github: "https://github.com/ombhaltilak/Offline-Document-Finder-ODF-AI-Semantic-Search-Engine",
  },
  {
    id: "3",
    name: "Food Delivery Web App",
    image: "/food-app-thumb.png",
    icons: [BiLogoReact, BiLogoTailwindCss, BiLogoJavascript],
    shortDesc: "Full-featured food ordering UI with Redux state management.",
    longDesc: [
      "Developed a responsive, single-page food delivery web app with category filtering, cart functionality, quantity control, and dynamic cost calculation.",
      "Implemented Redux Toolkit for centralized state management, ensuring consistent updates across components.",
      "Designed a modern, mobile-first UI using Tailwind CSS with adaptive layouts for cross-device compatibility.",
      "Optimized rendering with Redux state slices and modular React components, enabling real-time cart updates and smooth user experience."
    ],
    techStack: "React.js, Tailwind CSS, Redux Toolkit, Netlify.",
    github: "https://github.com/ombhaltilak/Food_Delivery",
    demo: "https://food-delivery-app-by-om-bhaltilak.netlify.app/",
  }
];

export default ProjectsData;